<template>
  <div class="container">
    <div class="button" @click="handleSubmit">
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { Dialog } from 'vant'
export default {
  methods: {
    handleSubmit () {
      activityApi.posterSubmit().then(res => {
        if (res.data.resultCode === '0') {
          Dialog.alert({
            message: '恭喜你，报名成功'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.container{
  width: 100vw;
  height: 150vw;
  background-image: url('../../assets/images/activity/activity-poster-submit.jpg');
  background-size: 100vw 150vw;
}
.button{
  width: 42vw;
  height: 50px;
  position:absolute;
  top: 63vw;
  left: 5vw;
}
</style>
